export default "__VITE_ASSET__BjrolBTA__"